import HttpClienteToken from '../../services/HttpClientToken';

import { AplicacionProps } from '../../interfaces/catalogos/AplicacionInterface';

export const Aplicaciones = () => {

    return new Promise<AplicacionProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Aplicacion/', token)
            .then( ({ data } : { data : AplicacionProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerAplicaciones = () => {

    return new Promise<AplicacionProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Aplicacion/ObtenerAplicaciones', token)
            .then( ({ data } : { data : AplicacionProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarAplicacion = ( params: AplicacionProps ) => {

    return new Promise<AplicacionProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Aplicacion/Actualizar', params, token)
            .then( ({ data } : { data : AplicacionProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idAplicacion: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarAplicacion = ( params: AplicacionProps ) => {

    return new Promise<AplicacionProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Aplicacion/Agregar', params, token)
            .then( ({ data } : { data : AplicacionProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idAplicacion: 0,
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}